<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">任务管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>{{ isCreate ? "创建临时任务" : "长期巡查任务" }}</div>
        </div>
      </div>
    </div>
    <div class="section" v-if="!isCreate">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%; width: 100%">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <!-- <el-form-item label="点位名称">
                <el-input
                  v-model="form.pointName"
                  clearable
                  placeholder="请输入点位名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="点位类型">
                <el-select
                  filterable
                  placeholder="请选择点位类型"
                  clearable
                  v-model="form.ghPointTypeId"
                >
                  <el-option
                    v-for="item in pointTypeOptions"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="所属社区">
                <el-select
                  filterable
                  placeholder="请选择所属社区"
                  clearable
                  v-model="communityCode"
                  @change="commcommunityChange"
                >
                  <el-option
                    v-for="item in commcommunityList"
                    :key="item.id"
                    :label="item.pointName"
                    :value="item.id + '-' + item.pointName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属网格">
                <el-select
                  filterable
                  placeholder="请选择所属网格"
                  clearable
                  v-model="form.blockName"
                >
                  <el-option
                    v-for="item in blockList"
                    :key="item.deptCode"
                    :label="item.pointName"
                    :value="item.pointName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="事项类型">
                <el-select
                  filterable
                  placeholder="请选择事项类型"
                  clearable
                  v-model="form.ghEventTypeId"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.sxlx"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="事项名称">
                <!-- <el-input
                  v-model="form.eventName"
                  clearable
                  placeholder="请输入事项名称"
                ></el-input> -->
                <el-select
                  placeholder="请选择事项名称"
                  v-model="form.eventName"
                  filterable
                >
                  <el-option
                    v-for="item in eventList"
                    :key="item.id"
                    :label="item.sxmc"
                    :value="item.sxmc"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="是否超时">
                <el-select
                  filterable
                  placeholder="请选择是否超时"
                  clearable
                  v-model="form.sfcsFlag"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="任务状态">
                <el-select
                  filterable
                  placeholder="请选择任务状态"
                  clearable
                  v-model="form.taskStatus"
                >
                  <el-option label="待执行" value="待执行"></el-option>
                  <el-option label="已完成" value="已完成"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否督办">
                <el-select
                  filterable
                  placeholder="请选择是否督办"
                  clearable
                  v-model="form.overseeFlag"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item label="责任人类型">
                <el-select
                  filterable
                  placeholder="请选择责任人类型"
                  clearable
                  v-model="form.eventZrrlx"
                >
                  <el-option
                    v-for="item in zrrlxOptions"
                    :key="item.id"
                    :label="item.data.itemName"
                    :value="item.data.itemName"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item label="任务创建时间">
                <el-date-picker
                  v-model="form.times"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-form-item> -->

              <!-- <el-form-item label="是否应急任务">
                <el-select
                  filterable
                  placeholder="请选择是否应急任务"
                  clearable
                  v-model="form.taskLevel"
                >
                  <el-option label="是" value="应急"></el-option>
                  <el-option label="否" value="一般"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div class="table-top-btns">
          <div class="left-btn"></div>
          <div class="right-btn">
            <el-button
              @click="dialogExportVisible = true"
              icon="el-icon-download"
              class="search"
              >科室提交导出</el-button
            >
          </div>
        </div>
        <common-table
          :select="false"
          :page="page"
          :maxHeight="500"
          :dataList="dataList"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        >
          <template v-slot:hasHour="{ scope }">
            <span
              style="color: #eb3538; font-size: 16px"
              v-if="scope.row.hasHour && scope.row.hasHour < 0"
              >已超时</span
            >
            <span
              style="color: #ff8b46; font-size: 16px"
              v-if="scope.row.hasHour && scope.row.hasHour >= 0"
              >剩余{{ scope.row.hasHour }}小时</span
            >
          </template>
          <template v-slot:taskLevel="{ scope }">
            <span v-if="scope.row.taskLevel == '应急'">是</span>
            <span v-else>否</span>
          </template>
          <template v-slot:taskStatus="{ scope }">
            <span
              style="color: #ff8b46; font-size: 16px"
              v-if="
                scope.row.hasHour &&
                  scope.row.hasHour >= 0 &&
                  scope.row.taskStatus == '待执行'
              "
              >待执行</span
            >
            <span
              style="color: #eb3538; font-size: 16px"
              v-if="
                scope.row.hasHour &&
                  scope.row.hasHour < 0 &&
                  scope.row.taskStatus == '待执行'
              "
              >待执行</span
            >
            <span
              style="color: #81b337; font-size: 16px"
              v-if="scope.row.taskStatus == '已完成'"
              >已完成</span
            >
          </template>
          <template v-slot:overseeFlag="{ scope }">
            <span v-if="scope.row.overseeFlag == 1">是</span>
            <span v-else>否</span>
          </template>
          <template v-slot:operation="{ scope }">
            <el-button
              @click="openDialog(scope.row)"
              style="color: #0090ff; font-size: 16px"
              type="text"
              >巡查记录</el-button
            >
            <el-button
              @click="delTaskFun(scope.row.id)"
              style="color: #eb3538; font-size: 16px"
              type="text"
              >删除</el-button
            >
          </template>
        </common-table>
      </div>
    </div>
    <create @back="back" class="section" v-else></create>
    <addDialog
      v-if="dialogVisible"
      @refreshList="taskPageFun"
      :dialogVisible.sync="dialogVisible"
      :curId="curId"
    >
    </addDialog>
    <exportDialog
      v-if="dialogExportVisible"
      :dialogVisible.sync="dialogExportVisible"
    >
    </exportDialog>
  </div>
</template>
<script>
import { selList, eventPage } from "@/api/base.js";
import { taskPage, delTask } from "@/api/task.js";
import { dictItemRoot } from "@/api/systemManagement.js";
import addDialog from "./components/addDialog.vue";
import commonTable from "@/components/table/index.vue";
import create from "./components/create.vue";
import moment from "moment";
import index from "@/mixins/index.js";
import exportDialog from "./components/exportDialog.vue";
export default {
  components: {
    addDialog,
    commonTable,
    create,
    exportDialog
  },
  mixins: [index],
  data() {
    return {
      form: {
        pointName: "",
        ghPointTypeId: "",
        communityCode: "",
        blockName: "",
        ghEventTypeId: "",
        eventName: "",
        sfcsFlag: "",
        taskStatus: "",
        overseeFlag: "",
        times: [],
        eventZrrlx: "",
        taskLevel: ""
      },
      dialogVisible: false,
      isCreate: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          // {
          //   slot: "hasHour",
          //   label: "是否超时",
          // },
          {
            prop: "pointName",
            label: "网格名称"
          },
          // {
          //   prop: "pointTypeName",
          //   label: "点位类型",
          // },
          {
            prop: "communityName",
            label: "所属社区"
          },
          // {
          //   prop: "blockName",
          //   label: "所属网格",
          // },
          {
            prop: "eventTypeName",
            label: "事项类型"
          },
          {
            prop: "eventName",
            label: "事项名称"
          },
          // {
          //   prop: "eventZrrlx",
          //   label: "责任人类型",
          // },
          {
            prop: "taskRuleCreatetime",
            label: "任务创建时间"
          },
          // {
          //   slot: "taskStatus",
          //   label: "任务状态",
          // },
          // {
          //   slot: "taskLevel",
          //   label: "是否应急任务",
          // },
          // {
          //   slot: "overseeFlag",
          //   label: "是否督办",
          // },
          {
            slot: "operation",
            label: "操作",
            width: 140
          }
        ]
      },
      curItem: {},
      curId: "",
      zrrlxOptions: [],
      typeList: [],
      dialogExportVisible: false,
      eventList: []
    };
  },
  mounted() {
    this.getCommcommunityAllFun();
    this.getPointTypeListPageFun();
    this.taskPageFun();
    this.selListFun();
    this.dictItemRootFun();
    this.eventPageFun();
  },
  methods: {
    async eventPageFun() {
      const res = await eventPage({
        page: 1,
        size: 99999,
        ghEventTypeId: 'd10c6dde183291179f06113d400f08bb'
      });
      if (res.data.code == 200) this.eventList = res.data.data.records;
    },
    async selListFun() {
      const res = await selList({ sxlx: "" });
      this.typeList = res.data.data || [];
    },
    async dictItemRootFun() {
      const { data } = await dictItemRoot({
        dictType: "GH_ZRRLX",
        data: true,
        pid: -1,
        page: 1,
        size: 9999
      });
      this.zrrlxOptions = data.data.dataList || [];
    },
    back() {
      this.isCreate = false;
      this.taskPageFun();
    },
    openDialog(item) {
      this.dialogVisible = true;
      this.curId = item.id;
    },
    createTaskFun(item) {
      this.isCreate = true;
      this.curItem = item;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.taskPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.taskPageFun();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.taskPageFun();
    },
    onReset() {
      this.communityCode = "";
      this.form.times = [];
      this.form.pointName = "";
      this.form.ghPointTypeId = "";
      this.form.communityCode = "";
      this.form.blockName = "";
      this.form.ghEventTypeId = "";
      this.form.eventName = "";
      this.form.sfcsFlag = "";
      this.form.taskStatus = "";
      this.form.overseeFlag = "";
      this.form.eventZrrlx = "";
      this.form.taskLevel = "";
      this.page.page = 1;
      this.page.size = 10;
      this.taskPageFun();
    },
    // 删除
    async delTaskFun(id) {
      this.$confirm("是否删除该数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let params = {
            id: id
          };
          const res = await delTask(params);
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.onSearch();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 分页查询
    async taskPageFun() {
      let params = {
        pointName: this.form.pointName,
        ghPointTypeId: this.form.ghPointTypeId,
        communityName: this.form.communityCode,
        blockName: this.form.blockName,
        ghEventTypeId: this.form.ghEventTypeId,
        eventName: this.form.eventName,
        sfcsFlag: this.form.sfcsFlag,
        taskStatus: this.form.taskStatus,
        overseeFlag: this.form.overseeFlag,
        eventZrrlx: this.form.eventZrrlx,
        taskLevel: this.form.taskLevel,
        // searchTimeStart:
        //   this.form.times && this.form.times.length
        //     ? moment(this.form.times[0]).format("YYYY-MM-DD HH:mm:ss")
        //     : "",
        // searchTimeEnd:
        //   this.form.times && this.form.times.length
        //     ? moment(this.form.times[1]).format("YYYY-MM-DD HH:mm:ss")
        //     : "",
        searchSource: "BIG_SCREEN",
        page: this.page.page,
        size: this.page.size,
        eventSuperFlagStr: "EVENT_TYPE_TYPE_INFINITE"
      };
      const res = await taskPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.biaodan2 .biaodan-left .el-form-item {
  // width: 25%;
  // margin-right: 0 !important;
  // /deep/.el-input__inner,
  // /deep/.el-select,
  /deep/.el-date-editor {
    height: 40px;
    width: 360px !important;
  }
}
.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  // text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/longInspectionTask/index.vue